<template>
  <div
    v-if="$attrs.value"
  >
    <div
      class="webtotext-dialog ml-5 my-5"
    >
      <pp-button
        type="icon"
        class="webtotext-dialog__btn-close"
        icon="close"
        @click="closeDialog"
      />
      <h1
        class="webtotext-dialog__title text-h2"
      >
        {{ dialogTitle }}
      </h1>
      <h5
        class="webtotext-dialog__text text-h5"
      >
        {{ isMobile ? dialogTextMobile : dialogTextDesktop }}
      </h5>
      <div
        class="webtotext-dialog__btn mt-5"
      >
        <pp-button
          type="primary"
          class="elevation-24 webtotext-dialog__btn-ask"
          text="Ask"
          submit
          @click="openMessageForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { WebToTextConstants } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'WebToTextDialog',
  data () {
    return {
      dialogTitle: WebToTextConstants.DIALOG_TITLE,
      dialogTextDesktop: WebToTextConstants.DIALOG_TEXT_DESKTOP,
      dialogTextMobile: WebToTextConstants.DIALOG_TEXT_MOBILE
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  created () {
    // check if the user already clicked the dialog within the same session and don't show
    const dialogSessionKey = sessionStorage.getItem('dialogClicked')
    if (!dialogSessionKey || dialogSessionKey === 'false') {
      this.$emit('input', true)
    }
  },
  methods: {
    storeDialogClickedInSession () {
      sessionStorage.setItem('dialogClicked', 'true')
    },
    closeDialog () {
      this.storeDialogClickedInSession()
      this.$emit('input', false)

      this.trackGA({
        category: 'dialog',
        action: 'close'
      })
    },
    openMessageForm () {
      this.storeDialogClickedInSession()
      this.$emit('input', false)
      this.$emit('openMessageFormEvent')

      this.trackGA({
        category: 'dialog',
        action: 'open-form'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .webtotext-dialog {
    background: $white;
    border-radius: 10px;
    box-shadow: $box-shadow;
    min-width: 200px;
    padding: 32px;
    position: relative;

    @include desktop {
      min-width: 300px;
    }

    @include mobile {
      padding-bottom: 20px;
      padding-top: 20px;
      text-align: center;
    }

    &__btn-close {
      background: $white;
      height: 24px;
      position: absolute;
      right: 16px;
      top: 16px;
      width: 24px;

      ::v-deep {
        i {
          color: $color-synapse-1;
          font-size: 1.4rem;
        }
      }

      @include mobile {
        left: -12px;
        top: -11px;
      }
    }

    &__title {
      @include mobile {
        display: none;
      }
    }

    &__btn {
      display: flex;
      flex-direction: column;

      @include mobile {
        display: none;
      }
    }
  }
</style>
